<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { useClassStore, useSignalRStore } from '../../stores';
import Button from '../General/Button.vue';
import { TEXT } from '../../configs/text';
import lockWhiteIcon from '../../assets/icons/lock-white.svg';
import unlockIcon from '../../assets/icons/unlock.svg';
import { computed } from 'vue';

const classStore = useClassStore()
const signalr = useSignalRStore()

const isLockedScreen = computed(() => classStore.selectedClassDetails?.lockScreen || false)

function handleLockScreenClick() {
    signalr.lockScreen(!isLockedScreen.value)
}
const { t } = useI18n()
</script>

<template>
    <Button color="main" :type="isLockedScreen ? 'outline' : 'normal'" class="w-max"
        :class="{ '!bg-white hover:!bg-white focus:!bg-white hover:!text-orange-500 focus:!text-orange-500': isLockedScreen }"
        @click="handleLockScreenClick">
        <img :src="isLockedScreen ? unlockIcon : lockWhiteIcon" class="size-6"
            :class="{ 'group-hover:brightness-0 group-hover:invert group-focus:brightness-0 group-focus:invert': isLockedScreen }" />
        {{ t(isLockedScreen ? TEXT.unlock_screen : TEXT.lock_screen) }}
    </Button>
</template>